export const courtTypesByState = {
  "CA": [
    {
      code: "ADM",
      label: "Administrative Adjudication"
    },
    {
      code: "CIR",
      label: "Circuit Court"
    },
    {
      code: "DIS",
      label: "District Court"
    },
    {
      code: "FED",
      label: "U.S. District Court"
    },
    {
      code: "MUN",
      label: "Municipal Court"
    },
    {
      code: "SSP",
      label: "State Supreme Court"
    },
    {
      code: "SUP",
      label: "Superior Court"
    }
  ],
  "MI": [
    {
      code: "ADM",
      label: "Administrative Adjudication"
    },
    {
      code: "CIR",
      label: "Circuit Court"
    },
    {
      code: "CIV",
      label: "Civil Court"
    },
    {
      code: "DIS",
      label: "District Court"
    },
    {
      code: "DOT",
      label: "Secretary USDOT"
    },
    {
      code: "FED",
      label: "U.S. District Court"
    },
    {
      code: "JPC",
      label: "Justice of Peace Court"
    },
    {
      code: "JUS",
      label: "Justice Court"
    },
    {
      code: "JUV",
      label: "Juvenile Court"
    },
    {
      code: "MAG",
      label: "Magistrate Court"
    },
    {
      code: "MUN",
      label: "Municipal Court"
    },
    {
      code: "SUP",
      label: "Superior Court"
    },
    {
      code: "TRA",
      label: "Traffic Court"
    },
    {
      code: "TRI",
      label: "Tribal Court"
    },
    {
      code: "UNK",
      label: "Unknown"
    }
  ],
  "OR": [
    {
      code: "ADM",
      label: "Administrative Adjudication"
    },
    {
      code: "CIR",
      label: "Circuit Court"
    },
    {
      code: "DIS",
      label: "District Court"
    },
    {
      code: "FED",
      label: "U.S. District Court"
    },
    {
      code: "JUS",
      label: "Justice Court"
    },
    {
      code: "JUV",
      label: "Juvenile Court"
    },
    {
      code: "MUN",
      label: "Municipal Court"
    }
  ],
  "DEFAULT": [
    {
      code: "ADM",
      label: "Administrative Adjudication"
    },
    {
      code: "CHA",
      label: "Chancery Court"
    },
    {
      code: "CIR",
      label: "Circuit Court"
    },
    {
      code: "CIT",
      label: "City Court"
    },
    {
      code: "CIV",
      label: "Civil Court"
    },
    {
      code: "COC",
      label: "County Court"
    },
    {
      code: "COR",
      label: "Corporation Court"
    },
    {
      code: "CRI",
      label: "Criminal Court"
    },
    {
      code: "DIS",
      label: "District Court"
    },
    {
      code: "DOT",
      label: "Secretary USDOT"
    },
    {
      code: "FED",
      label: "U.S. District Court"
    },
    {
      code: "GEN",
      label: "General Court Martial"
    },
    {
      code: "HUS",
      label: "Hustings Court"
    },
    {
      code: "JPC",
      label: "Justice of Peace Court"
    },
    {
      code: "JUS",
      label: "Justice Court"
    },
    {
      code: "JUV",
      label: "Juvenile Court"
    },
    {
      code: "LEC",
      label: "Law & Equity Court"
    },
    {
      code: "MAG",
      label: "Magistrate Court"
    },
    {
      code: "MAY",
      label: "Mayor's Court"
    },
    {
      code: "MUN",
      label: "Municipal Court"
    },
    {
      code: "POL",
      label: "Police Court"
    },
    {
      code: "SJC",
      label: "Special Justice Court"
    },
    {
      code: "SPL",
      label: "Special Court Martial"
    },
    {
      code: "SSP",
      label: "State Supreme Court"
    },
    {
      code: "SUM",
      label: "Summary Court Martial"
    },
    {
      code: "SUP",
      label: "Superior Court"
    },
    {
      code: "TJC",
      label: "Trial Justice Court"
    },
    {
      code: "TRA",
      label: "Traffic Court"
    },
    {
      code: "TRI",
      label: "Tribal Court"
    },
    {
      code: "TWN",
      label: "Town Court"
    },
    {
      code: "UNK",
      label: "Unknown"
    },
    {
      code: "USC",
      label: "U.S. Commissioner"
    },
    {
      code: "USM",
      label: "U.S. Magistrate Court"
    },
    {
      code: "USS",
      label: "U.S. Supreme Court"
    }
  ]
};